import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

// Services.
import { DictStorageService } from '../dict-storage/dict-storage.service';
import { LoggerService, LogLevel } from '../logger/logger.service';

// Classes.
import { Article } from '../../classes/article';
import { IndexItem } from '../../classes/indexItem';
import { RBImage } from '../../classes/image';
import { Logger } from '../../classes/logger';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  protected storage: { [index: string]: any } = {};

  protected logger: Logger;
  public loading = true;
  constructor(
    protected dictStorage: DictStorageService,
    loggerSrvc: LoggerService
  ) {
    this.logger = new Logger(loggerSrvc, this.constructor.name);
    this.logger.setLogLevel(LogLevel.WARNING)
  }

  public putLang(lang: Object) {
    localStorage.setItem('lang', JSON.stringify(lang));

  }
  public getLang(): { LangID: string } {
    if (localStorage.getItem('lang') == null) {
      this.putLang({});
    }
    return JSON.parse(localStorage.getItem('lang'));
  }
  public setLangs(lang: string): void {
    this.dictStorage.put('langs', lang);

  }
  public getLangs(): Array<any> {
    return this.dictStorage.get('langs');
  }
  // Article methods.
  ///////////////////

  public putArticle(article: Article): void {
    this.logger.log(`Storing Article with id "${article.id}"`, article);
    this.dictStorage.put(this.articleKeyFromId(article.id), article);
  }

  public getArticle(articleId: string): Article {
    let article = this.dictStorage.get(this.articleKeyFromId(articleId));
    this.logger.log(`Recovering Article with id "${this.articleKeyFromId(articleId)}"`, article);
    return article;
  }

  protected articleKeyFromId(id: string): string {
    return 'art-' + id + 'lang-' + this.getLang().LangID;
  }


  // IndexItem methods.
  /////////////////////

  public putIndexItem(indexItem: IndexItem): void {
    this.logger.log(`Storing IndexItem with id "${indexItem.id}"`, indexItem);
    this.dictStorage.put(this.indexItemKeyFromId(indexItem.id), indexItem);
  }

  public getIndexItem(indexItemId: string): IndexItem {
    let indexItem = this.dictStorage.get(this.indexItemKeyFromId(indexItemId));
    this.logger.log(`Recovering IndexItem with id "${indexItemId}"`, indexItem);
    return indexItem;
  }

  protected indexItemKeyFromId(id: string): string {
    return 'idx-' + id + 'lang-' + this.getLang().LangID;
  }


  // Image methods.
  /////////////////

  public putImage(image: RBImage): void {
    this.logger.log(`Storing RBImage with id "${image.id}"`, image);
    this.dictStorage.put(this.imageKeyFromId(image.id), image);
  }

  public getImage(imageId: number): RBImage {
    let image = this.dictStorage.get(this.imageKeyFromId(imageId));
    this.logger.log(`Recovering RBImage with id "${imageId}"`, image);
    return image;
  }

  protected imageKeyFromId(id: number): string {
    return 'img-' + id + 'lang-' + this.getLang().LangID;
  }


  // Flying page methods.
  ///////////////////

  public putFlyingPage(flyingPage: Article): void {
    this.logger.log(`Storing FlyingPage with id "${flyingPage.id}"`, flyingPage);
    this.dictStorage.put(this.flyingPageKeyFromId(flyingPage.id), flyingPage);
  }

  public getFlyingPage(flyingPageId: string): Article {
    let flyingPage = this.dictStorage.get(this.flyingPageKeyFromId(flyingPageId));
    this.logger.log(`Recovering FlyingPage with id "${flyingPageId}"`, flyingPage);
    return flyingPage;
  }

  protected flyingPageKeyFromId(id: string): string {
    return 'flyp-' + id + 'lang-' + this.getLang().LangID;
  }
}
